module.exports = __webpack_public_path__ + "../../static/img/header-logo.92958ba6.png";